if (!customElements.get('bp-christmas-buy')) {
  customElements.define('bp-christmas-buy', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('input[type="radio"][name="id"]')) return;
        const choice = event.target;
        const button = this.querySelector('button[type="submit"]');
        const available = choice.dataset.available === 'true';
        button.disabled = !available;
        button.removeAttribute('aria-disabled');
        button.querySelector('span').textContent = available || choice.dataset.preview ? this.dataset.buyLabel : this.dataset.unavailableLabel;
        const productForm = this.querySelector('product-form');
        if (productForm && typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
      });
    }
  });
}
